

document.addEventListener('DOMContentLoaded', function () {
    addAccountMenuVisibilityListeners();
    updateScrollToTopButtonVisibility();
    addOutlineClass();
    sideCartVisibility();
    tabSection();
    addRemoveItemListeners();
    selectOptionVisibility();
    selectOptionGridVisibility();
    addInitedBodyClass();
    mobileMenuVisibility();
    browserAgent();
    preloaderInit();

    window.addEventListener('recommendedInitialized', selectOptionVisibility);
    window.addEventListener('aftercollectionform', selectOptionVisibility);

    function addInitedBodyClass() {
        const openMenuClassName = 'inited';
        document.body.classList.add(openMenuClassName);
    }

    window.addEventListener('scroll', updateScrollToTopButtonVisibility)

    function addAccountMenuVisibilityListeners() {
        const elemCheck = document.querySelectorAll('.site-header__account');
        if ( elemCheck.length !== 0 ) {
            elemCheck.forEach( function(perAccount) {
                const openMenuClassName = 'open';
                const ellipsis = perAccount;
                const menu = perAccount.querySelector('.account-list');
        
                ellipsis.addEventListener('click', function (event) {
                    event.stopPropagation()
                    menu.classList.toggle(openMenuClassName)
                });
                ellipsis.addEventListener('keypress', function (event) {
                    event.stopPropagation()
                    menu.classList.toggle(openMenuClassName)
                });
        
                document.querySelector('body').addEventListener('click', function (event) {
                    if (event.target === menu) {
                        return
                    }
        
                    menu.classList.remove(openMenuClassName)
                })
            } )
        }
        
    }

    document.querySelectorAll('.scroll-to-top').forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault()
            window.scroll({ top: 0, behavior: 'smooth' })
        })
    })
    
    function updateScrollToTopButtonVisibility() {
        if (window.scrollY > 20) {
            document.querySelectorAll('.scroll-to-top').forEach(function (button) {
                button.classList.remove('hidden')
            })

            return
        }

        document.querySelectorAll('.scroll-to-top').forEach(function (button) {
            button.classList.add('hidden')
        })
    }

    function addOutlineClass() {
        const body = document.querySelector('body');
        body.addEventListener( 'keydown', function( event ) {
            if ( 9 == event.which ) {
                if ( ! body.classList.contains( 'show_outline' ) ) {
                    body.classList.add( 'show_outline' );
                }
            }
        })
    }

    document.addEventListener('cartChanged', function () {
        sendRequest('/cart.js', 'GET', reRenderCartSidebar)
    })

    function addRemoveItemListeners() {
        document.querySelectorAll('.cart_item_remove').forEach(function(line, index) {
            line.addEventListener('click', function () {
                sendRequest('/cart/change.js', 'POST', reRenderCartSidebar, 'quantity=0&line=' + (index + 1))
            })
        })
    }

    function sendRequest(url, method, callback, params) {
        const xmlHttp = new XMLHttpRequest

        xmlHttp.open(method, url, true)

        xmlHttp.onreadystatechange = function () {
            if (4 === xmlHttp.readyState && 200 === xmlHttp.status) {
                callback(xmlHttp.responseText)
            }
        }

        if ('POST' === method) {
            xmlHttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        }

        xmlHttp.send(params)
    }

    function reRenderCartSidebar(cartJson) {
        if( document.querySelectorAll('.side-cart-wrapper').length > 0 ) {
            const sideCartWrapper = document.querySelector('.side-cart-wrapper')
            const cart = JSON.parse(cartJson)
    
            updateHeaderCartItemCounter(cart['item_count'])
    
            if (0 === cart['item_count']) {
                const p = document.createElement('p')
                p.classList.add('empty')
                p.textContent = translate('empty')
    
                sideCartWrapper.innerHTML = ''
                sideCartWrapper.appendChild(p)
    
                return
            }
    
            const empty = sideCartWrapper.querySelector('p.empty')
    
            if (empty !== null) {
                empty.remove()
            }
    
            const itemWrapper = createItemWrapper(sideCartWrapper)
    
            sideCartWrapper.innerHTML = ''
            sideCartWrapper.appendChild(itemWrapper)
    
            const ol = document.createElement('OL')
            ol.id = 'mini-cart'
            ol.className = 'side-cart-items'
            itemWrapper.appendChild(ol)
    
            cart.items.map(function (item) {
                ol.appendChild(createItemNode(item))
            })
    
            itemWrapper.appendChild(createSubTotal(cart['total_price']))
            itemWrapper.appendChild(createActions())
    
            addRemoveItemListeners()
        }
    }

    function createItemWrapper() {
        const wrapper = document.createElement('DIV')
        wrapper.className = 'side-cart-items-wrapper'

        return wrapper
    }

    function createItemNode(item) {

        const li = document.createElement('li')
        li.className = 'product-item'

        const wrapper = document.createElement('div')
        wrapper.className = 'product'
        li.appendChild(wrapper)

        const cartRemoveWrapper = document.createElement('div')
        cartRemoveWrapper.className = 'cart_item_remove'
        wrapper.appendChild(cartRemoveWrapper)

        const cartRemoveSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
        cartRemoveSvg.classList.add('icon', 'icon-close')
        cartRemoveSvg.setAttribute('viewBox', '0 0 18 17')
        cartRemoveSvg.innerHTML = '<path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>'
        cartRemoveWrapper.appendChild(cartRemoveSvg)

        const productImageWrapper = document.createElement('a')
        productImageWrapper.className = 'product-item-photo'
        productImageWrapper.setAttribute('href', item['url'])
        wrapper.appendChild(productImageWrapper)

        const productImage = document.createElement('img')
        productImage.setAttribute('src', item['image'].replace(/(\.[^.]+)$/ism, '_72x72_crop_center$1'))
        productImage.setAttribute('alt', item['product_title'])
        productImageWrapper.appendChild(productImage)

        const productInfoWrapper = document.createElement('div')
        productInfoWrapper.className = 'product-item-details'
        wrapper.appendChild(productInfoWrapper)

        const productNameWrapper = document.createElement('div')
        productNameWrapper.className = 'product-item-name'
        productInfoWrapper.appendChild(productNameWrapper)

        const productName = document.createElement('a')
        productName.setAttribute('href', item['url'])
        productName.textContent = item['product_title']
        productNameWrapper.appendChild(productName)

        const productItemOptions = document.createElement('dl')
        productItemOptions.classList.add('product-item-options')
        productItemOptions.classList.add('options')
        productInfoWrapper.appendChild(productItemOptions)

        const optionsArray = item['options_with_values'];
        optionsArray.forEach(function(optionItem) {
            if(optionsArray['name'] !== 'Title' && optionItem['value'] !== 'Default Title') {
                const productInnerOptionsItem = document.createElement('span')
                productInnerOptionsItem.classList.add('option_item')
                productItemOptions.appendChild(productInnerOptionsItem)
        
                const productInnerOptionsItemLabel = document.createElement('dt')
                productInnerOptionsItemLabel.classList.add('label')
                productInnerOptionsItemLabel.innerText = optionItem['name'];
                productInnerOptionsItem.appendChild(productInnerOptionsItemLabel)
        
                const productInnerOptionsItemValue = document.createElement('dd')
                productInnerOptionsItemValue.classList.add('values')
                    productInnerOptionsItemValue.innerText = optionItem['value'];
                productInnerOptionsItem.appendChild(productInnerOptionsItemValue)
            }
        })

        const productDetailsWrapper = document.createElement('div')
        productDetailsWrapper.classList.add('details-product-wrapper')
        productInfoWrapper.appendChild(productDetailsWrapper)

        const productPriceWrapper = document.createElement('div')
        productPriceWrapper.classList.add('price')
        productDetailsWrapper.appendChild(productPriceWrapper)

        const quantity = document.createElement('span')
        quantity.textContent = item['quantity']
        productPriceWrapper.appendChild(quantity)

        const priceQuantitySeparator = document.createTextNode('\u00A0x\u00A0')
        productPriceWrapper.appendChild(priceQuantitySeparator)

        const price = document.createElement('span')
        price.classList.add('per')
        price.textContent = formatMoney(item['price'])
        productPriceWrapper.appendChild(price)

        return li;
    }

    function createSubTotal(amount) {
        const summary = document.createElement('div')
        summary.classList.add('summary')

        const subtotal = document.createElement('div')
        subtotal.classList.add('subtotal')
        summary.appendChild(subtotal)

        const title = document.createElement('span')
        title.classList.add('subtotal-title')
        title.textContent = translate('subtotal') + '\u00A0'
        subtotal.appendChild(title)

        const value = document.createElement('span')
        value.classList.add('subtotal-price')
        value.textContent = formatMoney(amount)
        subtotal.appendChild(value)

        return summary;
    }

    function createActions() {
        const actionsWrapper = document.createElement('div')
        actionsWrapper.classList.add('actions')

        const viewCartWrapper = document.createElement('div')
        viewCartWrapper.classList.add('viewcart')
        actionsWrapper.appendChild(viewCartWrapper)

        const viewCartLink = document.createElement('a')
        viewCartLink.classList.add('cart-popup__cta-link', 'button', 'anim_button')
        viewCartLink.setAttribute('href', '/cart')
        viewCartWrapper.appendChild(viewCartLink)

        const viewCartLabel = document.createElement('span')
        viewCartLabel.textContent = translate('view_cart')
        viewCartLink.appendChild(viewCartLabel)

        const checkoutWrapper = document.createElement('div')
        checkoutWrapper.classList.add('checkout')
        actionsWrapper.appendChild(checkoutWrapper)

        const checkoutLink = document.createElement('a')
        checkoutLink.classList.add('button', 'anim_button')
        checkoutLink.setAttribute('href', '/checkout')
        checkoutWrapper.appendChild(checkoutLink)

        const checkoutLabel = document.createElement('span')
        checkoutLabel.textContent = translate('checkout')
        checkoutLink.appendChild(checkoutLabel)

        return actionsWrapper;
    }

    function updateHeaderCartItemCounter(itemCount) {
        const counter = document.querySelector('.cart-count-bubble span')
        const mobCounter = document.querySelector('.mobile-cart-count-bubble span')

        if (null === counter && null === mobCounter) {
            return
        }

        if (parseInt(counter.textContent) === itemCount && parseInt(mobCounter.textContent) === itemCount) {
            return
        }

        if (0 === itemCount) {
            counter.textContent = 0;
            mobCounter.textContent = 0;
            return
        }

        counter.textContent = itemCount
        mobCounter.textContent = itemCount
    }

    function formatMoney(amount) {
        return translate('currency_format')
            .replace(/1/, amount.toString().substr(0, amount.toString().length - 2))
            .replace(/23/, amount.toString().substr(amount.toString().length - 2))
    }

    function translate(key) {
        return cartTranslations[key]
    }
    
    // Counters 
    if ( typeof(IntersectionObserver != 'undefined') && document.querySelectorAll('.counter-popup-section').length > 0 ) {
        document.querySelectorAll('.counter-popup-section').forEach( (section) => {
            const callback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        if ( document.querySelectorAll('.counter_blocks .counter_block_wrap').length > 0 ) {
                            const counters = document.querySelectorAll(".counter");
                            let speed = 100;
                            let countSpeed = 100;
                            counters.forEach((counter) => {
                                const eachCounterValue = counter.innerText    
                                counter.setAttribute('data-target', eachCounterValue);
                                counter.textContent = 0;
                                const updateCount = () => {
                                    const target = parseInt(+counter.getAttribute("data-target"));
                                    const count = parseInt(+counter.innerText);
                                    if ( target < 100 ) {
                                        speed = 5;
                                        countSpeed = 100;
                                    } else {
                                        speed = 100;
                                        countSpeed = 10;
                                    }
                                    const increment = Math.trunc(target / speed);
                                    if (count < target) {
                                    counter.innerText = count + increment;
                                    setTimeout(updateCount, countSpeed);
                                    } else {
                                    count.innerText = target;
                                    }
                                };
                                updateCount();
                            });    
                        }
                        myObserver.unobserve(section);
                    }
                });    
            };
            const options = {
                root: null,
                rootMargin: '100px',
                threshold: 0
            };  
            const myObserver = new IntersectionObserver(callback, options)
            myObserver.observe(section);
        });
    }
    function tabSection() {
        if ( document.querySelectorAll('.tabs-popup-section').length > 0 ) {
            let countTabs = document.querySelectorAll('.tabs-popup-section');

            countTabs.forEach((countTab) => {
                const tabs = countTab.querySelectorAll('[data-tab-target]');
                const tabContents = countTab.querySelectorAll('[data-tab-content]');
        
                tabs.forEach(tab => {
                    tab.addEventListener('click', () => {
                        const target = document.querySelector(tab.dataset.tabTarget)
                        tabContents.forEach(tabContent => {
                        tabContent.classList.remove('active')
                        })
                        tabs.forEach(tab => {
                        tab.classList.remove('active')
                        })
                        tab.classList.add('active')
                        target.classList.add('active')
                    })
                })    
            })
        }
    }
    function sideCartVisibility() {
        var elemCheck = document.querySelectorAll('.site-header__wrapper .header__icon--cart');
        if ( elemCheck.length != 0 ) {
            elemCheck.forEach( function(perCart) {
                const openCartClassName = 'open';
                const headerTrigger = perCart;
                const close = document.querySelector('.side.close');
                const sideCart = document.querySelector('.side_cart_wrap');
                const cartCover = document.querySelector('.back_cover');

        
                headerTrigger.addEventListener('click', function (event) {
                    event.stopPropagation()
                    sideCart.classList.add(openCartClassName)
                });
                headerTrigger.addEventListener('keypress', function (event) {
                    event.stopPropagation()
                    sideCart.classList.add(openCartClassName)
                });
    
                close.addEventListener('click', function (event) {
                    event.stopPropagation()
                    sideCart.classList.remove(openCartClassName)
                });

                cartCover.addEventListener('click', function (event) {
                    event.stopPropagation()
                    sideCart.classList.remove(openCartClassName)
                });
            } )
        }
    }
    function selectOptionVisibility() {
        var elements = document.querySelectorAll('.variable_wrap:not(.var_inited)');
        if ( elements.length >= 1 ) {
            elements.forEach(function(product) {
                product.classList.add('var_inited');
                const openOptionPopup = 'open';
                const bodyOpenOptionPopup = 'popup_open';
                const popupTrigger = product.querySelector('.variable_btn');
                const close = product.querySelector('.select_options_wrap .close');
                const popupProduct = product.querySelector('.select_options_wrap');
                const bodyPopupCover = document.querySelector('body');

                popupTrigger.addEventListener('click', function (event) {
                    event.stopPropagation();
                    popupProduct.classList.add(openOptionPopup)
                    bodyPopupCover.classList.add(bodyOpenOptionPopup);

                });
                popupTrigger.addEventListener('keypress', function (event) {
                    event.stopPropagation();
                    popupProduct.classList.add(openOptionPopup)
                    bodyPopupCover.classList.add(bodyOpenOptionPopup);
                });
    
                close.addEventListener('click', function (event) {
                    event.stopPropagation();
                    popupProduct.classList.remove(openOptionPopup);
                    bodyPopupCover.classList.remove(bodyOpenOptionPopup);
                });
            } )
        }
    }
    function selectOptionGridVisibility() {
        var elements = document.querySelectorAll('.grid_variable_wrap:not(.prod_inited)');
        if ( elements.length >= 1 ) {
            elements.forEach(function(product) {
                product.classList.add('prod_inited');
                const openOptionPopup = 'open';
                const bodyOpenOptionPopup = 'popup_open';
                const popupTrigger = product.querySelector('.grid_variable_btn');
                const close = product.querySelector('.select_options_wrap .close');
                const popupProduct = product.querySelector('.select-options-grid-wrapp .select_options_wrap');
                const bodyPopupCover = document.querySelector('body');

                popupTrigger.addEventListener('click', function (event) {
                    event.stopPropagation();
                    popupProduct.classList.add(openOptionPopup)
                    bodyPopupCover.classList.add(bodyOpenOptionPopup);

                });
                popupTrigger.addEventListener('keypress', function (event) {
                    event.stopPropagation();
                    popupProduct.classList.add(openOptionPopup)
                    bodyPopupCover.classList.add(bodyOpenOptionPopup);
                });
    
                close.addEventListener('click', function (event) {
                    event.stopPropagation();
                    popupProduct.classList.remove(openOptionPopup);
                    bodyPopupCover.classList.remove(bodyOpenOptionPopup);
                });
            } )
        }
    }
    if ( window.innerWidth < 1280 ) {
        var elemCheck = document.getElementsByClassName('sidebar-toogle');
        if ( elemCheck.length != 0 ) {
            const openMenuClassName = 'open';
            const ellipsis = document.querySelector('.sidebar-toogle');
            const close = document.querySelector('.sidebar-close');
            const menu = document.querySelector('.side_slide_sidebar');
            const sidebarCover = document.querySelector('.sidebar_back_cover');
    
            ellipsis.addEventListener('click', function (event) {
                event.stopPropagation()
                menu.classList.add(openMenuClassName)
            });
            ellipsis.addEventListener('keypress', function (event) {
                event.stopPropagation()
                menu.classList.add(openMenuClassName)
            });

            close.addEventListener('click', function (event) {
                event.stopPropagation()
                menu.classList.remove(openMenuClassName)
            });

            sidebarCover.addEventListener('click', function (event) {
                event.stopPropagation()
                menu.classList.remove(openMenuClassName)
            });

        }
    }
    function mobileMenuVisibility() {
        var elemCheck = document.querySelectorAll('.site-header__wrapper .site-header__mob_menu');
        if ( elemCheck.length != 0 ) {
            elemCheck.forEach( function(perTriger) {
                const openMobClassName = 'open';
                const headerTrigger = perTriger;
                const close = document.querySelector('.menu-toogle .icon-close-wrap .icon-close');
                const sideCart = document.querySelector('.menu-toogle');
                const mobCover = document.querySelector('.menu-toogle .back_cover');

        
                headerTrigger.addEventListener('click', function (event) {
                    event.stopPropagation()
                    sideCart.classList.add(openMobClassName)
                });
                headerTrigger.addEventListener('keypress', function (event) {
                    event.stopPropagation()
                    sideCart.classList.add(openMobClassName)
                });
    
                close.addEventListener('click', function (event) {
                    event.stopPropagation()
                    sideCart.classList.remove(openMobClassName)
                });

                mobCover.addEventListener('click', function (event) {
                    event.stopPropagation()
                    sideCart.classList.remove(openMobClassName)
                });
            } )
        }
    }

    function browserAgent() {
        let userBrowserclass = '';
        if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) {
            userBrowserclass = 'shopy_opera';
        } else if(navigator.userAgent.indexOf("Chrome") != -1 ) {
            userBrowserclass =  'shopy_chrome';
        } else if(navigator.userAgent.indexOf("Safari") != -1) {
            userBrowserclass = 'shopy_safari';
        } else if(navigator.userAgent.indexOf("Firefox") != -1 ){
            userBrowserclass = 'shopy_firefox';
        } else if(navigator.userAgent.indexOf("Edge") != -1 ) {
            userBrowserclass = 'shopy_edge';
        } else if(navigator.userAgent.indexOf("Trident") != -1 ) {
            userBrowserclass = 'shopy_ie';
        }
        document.body.classList.add(userBrowserclass);
    }

    

    function preloaderInit() {
        const elemCheck = document.querySelector('.page_preloader');
        const fadeOut = function(el, timeout, pointer ) {
            el.style.opacity = 1;
            el.style.transition = `opacity ${timeout}ms`;
            setTimeout(() => {
                el.style.opacity = 0;
                el.style.pointerEvents = pointer;
            }, timeout);
        };
        fadeOut(elemCheck, 400, 'none' );
    }
    window.addEventListener('beforeunload', function() {
        const elemCheck = document.querySelector('.page_preloader');
        const fadeIn = function(el, timeout, pointer ) {
            el.style.opacity = 0;
            el.style.transition = `opacity ${timeout}ms`;
            setTimeout(() => {
                el.style.opacity = 1;
                el.style.pointerEvents = pointer;
            }, timeout);
        };
        fadeIn(elemCheck, 300, 'none' );
        setTimeout(preloaderInit, 5000);
    });

})


setTimeout(function() {
    const preloader = document.querySelector('.page_preloader');
    if (preloader) {
        preloader.style.opacity = 0;
        preloader.style.pointerEvents = 'none';
    }
}, 2000);